
















































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import MyTitle from "@/components/Title.vue";
import { getInvitationProgress, getInvitationReco } from "@/api";
export const DEFAULT_AVATAR =
  "https://tmp.btclass.cn/yunyin/o_1ge1rhfcu17a8vv7seq1spc1cioa.png";
function limitFrequency(timeout = 20) {
  return function(target: any, key: any, descriptor: any) {
    const oldValue = descriptor.value;
    let timer: any = null;
    descriptor.value = function() {
      clearTimeout(timer);
      timer = setTimeout(() => {
        oldValue.apply(this, arguments);
      }, timeout);
    };
    return descriptor;
  };
}

@Component({
  components: {
    MyTitle
  }
})
export default class InvitedUser extends Vue {
  @Prop({ type: String }) title?: string;
  @Prop({ type: Number, default: 0 }) id?: string;
  @Prop({ type: String, default: "暂无数据" }) emptyTips?: string;
  @Prop({ type: Boolean, default: true }) hasQa!: boolean;
  @Prop({ type: Boolean }) loading!: boolean;
  @Prop({ type: Boolean, default: () => false }) isActPage!: boolean;
  list: Array<any> = [];
  params: any = {
    page: 0,
    limit: 10,
    loading: true
  };
  hasMore: boolean = false;
  created() {
    console.log(this.id);
    this.getList();
  }
  async getList() {
    let opt = {
      page: this.params.page,
      limit: this.params.limit,
      needCount: 1,
      actId: this.id,
      subscribe: 1
    };
    let { rows, count } = await getInvitationReco(opt);
    this.hasMore = count - (opt.page + 1) * opt.limit > 0;
    this.params.page++;
    this.params.loading = false;
    if (opt.page === 0) {
      this.list = rows;
    } else {
      this.list = this.list.concat(rows);
    }
    this.list = this.list.map(item => {
      item.avatar = item.avatar || DEFAULT_AVATAR;
      return item;
    });
  }
  @limitFrequency(20)
  onScroll(e: any) {
    if (
      e.target.scrollTop + e.target.clientHeight >=
        e.target.scrollHeight - 100 &&
      this.hasMore &&
      !this.params.loading
    ) {
      this.params.loading = true;
      this.getList();
    }
  }
}
